import {
	Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewChild, ViewChildren, QueryList, ChangeDetectorRef
} from '@angular/core';
import { Integration, IntegrationNames, IntegrationTable } from '../../../DiscoveryEngine.TS/Core/Integration';
import { MessageService } from 'base';
import { ConfigurationService } from '../../services/configuration.service';
import { Observable, Subject, Subscription } from 'rxjs/Rx';


@Component({
	selector: 'integration-settings',
	templateUrl: './integration-settings.component.html',
	styleUrls: ['./integration-settings.component.scss'],
})
export class IntegrationSettingsComponent {

	public ITGlue = "ITGlue";
	public Halo = "Halo";
	public Hudu = "Hudu";
	public AssetPanda = "Asset Panda";
	public Jira = "Jira";
	public PatchManager = "Patch Manager";
	public ServiceNow = "ServiceNow";
	public Slack = "Slack";
	public NinjaOne = "ninjaOne";
	public Lucidchart = "Lucidchart";
	public Integrations: string[] = [this.ITGlue, this.Halo, this.Hudu, this.AssetPanda, this.Jira, this.PatchManager, this.ServiceNow, this.NinjaOne, this.Lucidchart, this.Slack];

	public selectedIntegration: string | null = null;

	public AssetPandaSettings: Integration = new Integration(IntegrationNames.AssetPanda);
	public HaloSettings: Integration = new Integration(IntegrationNames.Halo);
	public HuduSettings: Integration = new Integration(IntegrationNames.Hudu);
	public ITGlueSettings: Integration = new Integration(IntegrationNames.ITGlue);
	public JiraSettings: Integration = new Integration(IntegrationNames.Jira);
	public PatchManagerSettings: Integration = new Integration(IntegrationNames.PatchManager);
	public ServiceNowSettings: Integration = new Integration(IntegrationNames.ServiceNow);
	public NinjaOneSettings: Integration = new Integration(IntegrationNames.NinjaOne);
	public LucidchartSettings: Integration = new Integration(IntegrationNames.Lucidchart);
	public SlackSettings: Integration = new Integration(IntegrationNames.Slack);

	private onIntegrationSettingsLoadedSub: Subscription;

	constructor(private configService: ConfigurationService, private messageService: MessageService, private changeDetector: ChangeDetectorRef) {
	}

	private get integrationTable() { return this.configService.integrationTable; }

	public ngOnInit(): void {
		if (this.configService.hasIntegrationTable) {
			this.initIntegrationSettings();
		} else {
			this.configService.getIntegrationTable();
			this.onIntegrationSettingsLoadedSub = this.configService.onIntegrationTableLoaded.subscribe(
				() => {
					this.initIntegrationSettings();
				},
				() => {
					this.messageService.displayErrorMessage("Failed to retrieve default integration settings");
					console.error("Could not get the integration table");
				});
		}
	}

	private initIntegrationSettings(): void {
		if (!this.integrationTable) {
			return; 
		}
		this.AssetPandaSettings = new Integration(IntegrationNames.AssetPanda);
		this.HaloSettings = new Integration(IntegrationNames.Halo);
		this.HuduSettings = new Integration(IntegrationNames.Hudu);
		this.ITGlueSettings = new Integration(IntegrationNames.ITGlue);
		this.JiraSettings = new Integration(IntegrationNames.Jira);
		this.PatchManagerSettings = new Integration(IntegrationNames.PatchManager);
		this.ServiceNowSettings = new Integration(IntegrationNames.ServiceNow);
		this.NinjaOneSettings = new Integration(IntegrationNames.NinjaOne);
		this.LucidchartSettings = new Integration(IntegrationNames.Lucidchart);
		this.SlackSettings = new Integration(IntegrationNames.Slack);

		let assetPandaIntegration = this.integrationTable.Find(IntegrationNames.AssetPanda);
		if (assetPandaIntegration != null) {
			this.AssetPandaSettings = assetPandaIntegration;
		}

		let haloIntegration = this.integrationTable.Find(IntegrationNames.Halo);
		if (haloIntegration != null) {
			this.HaloSettings = haloIntegration;
		}

		let huduIntegration = this.integrationTable.Find(IntegrationNames.Hudu);
		if (huduIntegration != null) {
			this.HuduSettings = huduIntegration;
		}

		let itGlueIntegration = this.integrationTable.Find(IntegrationNames.ITGlue);
		if (itGlueIntegration != null) {
			this.ITGlueSettings = itGlueIntegration;
		}

		let jiraIntegration = this.integrationTable.Find(IntegrationNames.Jira);
		if (jiraIntegration != null) {
			this.JiraSettings = jiraIntegration;
		}

		let patchManagerIntegration = this.integrationTable.Find(IntegrationNames.PatchManager);
		if (patchManagerIntegration != null) {
			this.PatchManagerSettings = patchManagerIntegration;
		}

		let serviceNowIntegration = this.integrationTable.Find(IntegrationNames.ServiceNow);
		if (serviceNowIntegration != null) {
			this.ServiceNowSettings = serviceNowIntegration;
		}

		let ninjaOneIntegration = this.integrationTable.Find(IntegrationNames.NinjaOne);
		if (ninjaOneIntegration != null) {
			this.NinjaOneSettings = ninjaOneIntegration;
		}

		let lucidChartIntegration = this.integrationTable.Find(IntegrationNames.Lucidchart);
		if (lucidChartIntegration != null) {
			this.LucidchartSettings = lucidChartIntegration;
		}

		let slackIntegration = this.integrationTable.Find(IntegrationNames.Slack);
		if (slackIntegration != null) {
			this.SlackSettings = slackIntegration;
		}

		this.changeDetector.detectChanges();
	}

	public ngOnChanges(changes: SimpleChanges): void {

	}

	public ngOnDestroy(): void {
		this.onIntegrationSettingsLoadedSub?.unsubscribe();
		this.onIntegrationSettingsLoadedSub = undefined;
	}

	selectIntegration(integration: string): void {
		this.selectedIntegration = integration;
	}
}
